<div class="container">
    <form [formGroup]=whatsappVerificationForm  *ngIf="!user.iswhatsapp_verify">
        <span class="new bg-blue">New</span>


        <h4  *ngIf="!sent">Get latest updates <br> related to your profile on Whatsapp</h4>
        <h4  *ngIf="sent">Sent! A verification message has been sent to you on WhatsApp. Check it now.</h4>
      
        <div class="d-flex mobileinput position-relative" 
     [ngClass]="{'is-invalid': formSubmit && (mobileNumber.errors?.required || mobileNumber.errors?.minlength)}">

  <!-- Country Flag Trigger -->
    <div class="dropdown">
        <img src="../../assets/images/watsapp_logo_3d.svg" class="pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="countryflag">
        <img src="assets/images/fi_chevron-down-grey.svg" class="m-l-5 pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    <!-- Dropdown Menu -->
        <div class="dropdown-menu custom-dropdown" aria-labelledby="countryflag">
            <img src="assets/images/sd-chevron-up.svg" class="dropdown-caret">
            <div *ngFor="let country of countries; let i = index">
                <a class="dropdown-item" (click)="changeSelectedCountryCode(country.code, country.country_code)">
                 <span>{{ country.name }}</span>
                </a>
            </div>
        </div>
    </div>

  <!-- Input Fields -->
  <input type="tel" class="form-control-num" disabled formControlName="countrycode" [value]="placeholder"
         style="border-right: 1px solid #E0E3EB; width: 20%;">

  <input type="tel" class="form-control-num" noPaste
         formControlName="mobileNumber"
         placeholder="Mobile number"
         onkeydown="return ['Backspace','Delete','ArrowLeft','ArrowRight','Enter'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'">
</div>

        <mat-error *ngIf="formSubmit && mobileNumber.errors?.required">Mobile Number required</mat-error>
        <mat-error *ngIf="formSubmit && mobileNumber.errors?.minlength">Enter a valid number</mat-error>

        <a *ngIf="!sent" (click)="whatsappApi()" class="link mt-4" >Verify ></a>
        <a *ngIf="sent" class="link mt-4">&#10003;
            Sent</a>
    </form>



    <div class="boc" *ngIf="user.iswhatsapp_verify">
        <h4 class="d-block" *ngIf="user.iswhatsapp_verify">
            Congratulations! <img src="../../assets/images/congrats_blue_icon.svg" alt="congrats"
                style="margin-top: -28px;"> <br>
            Your Whatsapp number has been linked to your account
        </h4>

        <div class="mobileinput">
            <span>
                <img src="../../assets/images/verified_logo.svg" alt="verified">
            </span>
            <span class="form-control-num ml-3" style="color:#2222228C">

                {{user.whatsapp_number}}
            </span>
        </div>

    </div>
</div>
